// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__s0nOh","title":"Hero_title__noT7j","subTitle":"Hero_subTitle__RC5TC","searchBar":"Hero_searchBar__O33U8","break":"Hero_break___i5Tp"};